// extracted by mini-css-extract-plugin
module.exports = {"button":"SquareButton_button__2dAxd","button-disabled":"SquareButton_button-disabled__24whF"};